import { useState, useEffect } from "react";
import { api } from "../../lib/api.js";
import type { ProvidersResponse } from "./types.js";

export function useProviders() {
  const [data, setData] = useState<ProvidersResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    api
      .get<ProvidersResponse>("/auth/providers")
      .then(setData)
      .catch(() =>
        setData({ registrationMode: "closed", providers: ["password"] }),
      )
      .finally(() => setIsLoading(false));
  }, []);

  return { providers: data, isLoading };
}
